<template>
	<b-container fluid class="sous_block">

		<b-row v-if="mut_info[0]" align-h="center" align-v="center" class="my-3">
			<b-col >
				<b-table responsive hover :items="mut_info" :fields="fields_mut_info" class="text-center">
    	    <template #cell(evidences1)="row">
    	    	<span v-if="row.item.pred == 'Pathogenic'" class="text-white py-1 px-2" style="border-radius: 30px;background-color: red;">PM1</span>
            <span v-else-if="row.item.pred == 'Benign'" class="text-white py-1 px-2" style="border-radius: 30px;background-color: green;">BP8</span>
    	    	<span v-else class="my-auto py-1 px-2" >None</span>
    	    </template>
          <template #cell(evidences2)="row">
            <span v-if="parseFloat(row.item.af_max) >= 0.01" class="text-white py-1 px-2" style="border-radius: 30px;background-color: green;">BS1</span>
            <span v-else-if="parseFloat(row.item.af_max) <= 0.00001" class="text-white py-1 px-2" style="border-radius: 30px;background-color: red;">PM2</span>
            <!-- <span v-if="parseFloat(row.item.af_max) > 10^-5 && parseFloat(row.item.af_max) < 0.01" class="my-auto py-1 px-2" >None</span> -->
            <span v-else class="my-auto py-1 px-2" >None</span>
          </template>
    	    <template #cell(show_details)="row">
    	     <b-button size="sm" @click="row.toggleDetails" class="mr-2">
    	      {{ row.detailsShowing ? 'Hide' : 'Show'}} Details
    	     </b-button>
    	    </template>
    	    <template #row-details="row">
    	    	<div v-if="row.item.details.length === 0">
    	    		<div class="card">
    	    			<div class="card-body"><span>No data available</span></div>
    	    		</div>
    	    	</div>
    	    	<div v-else><details-table :items="row.item.details"></details-table></div>
    	    </template>
         <template #head(show_details)="row">
            <b-row style="flex-wrap: nowrap;">
              <b-col>
                <span>Frequency details</span>
              </b-col>
              <b-col align-self="center">
                <b-button variant="danger" size="sm" @click="prepare_download" v-b-tooltip.hover.right title="Download the variant table" ><i class="fas fa-file-download"></i></b-button>
              </b-col>
            </b-row>
         </template>
	   </b-table>
	  </b-col>
	  
	 </b-row>
   <b-row v-if="mut_info.length < 1">
     <b-overlay :show="mut_info.length < 1" no-wrap></b-overlay>
  </b-row>
 </b-container>
 </template>
 <script>

	export default {
		props: {
			domSelected: [String,Array],
			entryId: String,
			// ck:Number
 	},
 	data(){
 		return {
 			hmmData: "null",
        //fields_mut_info:[{label: 'Gene',key: 'gene',tdClass:'align-middle'},{label: 'Pfam ID',key: 'pfid',tdClass:'align-middle'},{label: 'Logo position',key: 'logo',tdClass:'align-middle'},{label: 'HGVSP',key: 'hgvsp',tdClass:'align-middle'},{label: 'WT',key: 'wt',tdClass:'align-middle'},{label: '∆',key: 'delta',tdClass:'align-middle'},{label: 'Prediction',key: 'pred',tdClass:'align-middle'},{label: 'Prediction probability',key: 'proba',tdClass:'align-middle'},{label: 'Evidences',key: 'evidences',tdClass:'align-middle'},{label: 'GnomAD frequency',key: 'af',tdClass:'align-middle'},{label: 'Dolphin frequency',key: 'af_max',tdClass:'align-middle'},{label:'Frequency details', key:'show_details'}],
        fields_mut_info:[{label: 'Gene',key: 'gene',tdClass:'align-middle'},{label: 'Pfam ID',key: 'pfid',tdClass:'align-middle'},{label: 'Logo position',key: 'logo',tdClass:'align-middle'},{label: 'HGVSP',key: 'hgvsp',tdClass:'align-middle'},{label: 'WT',key: 'wt',tdClass:'align-middle'},{label: '∆',key: 'delta',tdClass:'align-middle'},{label: 'Evidences',key: 'evidences1',tdClass:'align-middle'},{label: 'GnomAD frequency',key: 'af',tdClass:'align-middle'},{label: 'Dolphin frequency',key: 'af_max',tdClass:'align-middle'},{label: 'Evidences',key: 'evidences2',tdClass:'align-middle'},{label:'Frequency details', key:'show_details'}],
    mut_info:[],
    freq_info:Array,
    fields_details: [
    	{label: 'Entry Name', key: 'entry_name', sortable: true},
    	{label: 'Gene', key: 'gene', sortable: true},
    	{label: "HGVSP", key: 'hgvsp'},
    	{key: 'af', label: 'Frequency (GnomAD)', sortable: true, variant: 'danger'}]
    }
 		},
 		mounted(){
 			this.hmmData =this.domSelected
    // this.get_hmm_json(this.hmmData)
    this.fill_items();
    console.log('MUTATION TABLE Component mounted.')
    // console.log(this.hmmData)
 		},
 		methods:{
 			fill_items(){          
          for (var i = 0; i < this.hmmData.length; i++) {
            this.hmmData[i].entry_name = this.entryId
          }
          axios
          .post("/main/get_freq_info", this.hmmData)
          .then(response => { this.freq_info=response.data;
            var item1 = []
            for (var index = this.hmmData.length - 1; index >= 0; index--) { 
              var wt = this.hmmData[index].score.score_ref
              var mt = this.hmmData[index].score.score_alt
              var pred = this.prediction(wt,mt)
              var af_max = parseFloat(this.freq_info[index].mut_freq.af_max).toExponential()
              
              //item1.push({pfid:this.hmmData[index].pfid,wt:wt, delta:(mt-wt).toFixed(2),logo:parseFloat(this.freq_info[index].mut_freq.pos_in_logo),pred:pred, proba:this.prob_pred(wt,this.prediction(wt,mt)), af: parseFloat(this.freq_info[index].mut_freq.af).toExponential(), af_max: af_max, gene: this.freq_info[index].mut_freq.gene,hgvsp:'p.'+this.hmmData[index].AA.aa_ref+this.hmmData[index].pos_in_prot+this.hmmData[index].AA.aa_alt, evidences:'None', details: this.freq_info[index].details.map(obj => {obj.af = parseFloat(obj.af).toExponential(); return obj;})})
              this.gene = this.freq_info[index].mut_freq.gene
              item1.push({pfid:this.hmmData[index].pfid,wt:wt, delta:(mt-wt).toFixed(2),logo:parseFloat(this.freq_info[index].mut_freq.pos_in_logo),pred:pred, af: parseFloat(this.freq_info[index].mut_freq.af).toExponential(), af_max: af_max, gene: this.freq_info[index].mut_freq.gene,hgvsp:'p.'+this.hmmData[index].AA.aa_ref+this.hmmData[index].pos_in_prot+this.hmmData[index].AA.aa_alt, evidences1:'None',test:'',evidences2:'None', details: this.freq_info[index].details.map(obj => {obj.af = parseFloat(obj.af).toExponential(); return obj;})})
              this.gene = this.freq_info[index].mut_freq.gene
            }
            this.mut_info = item1
           })
          .catch(error => console.log(error))
        },
        prediction(wt,mt){
           var delta = mt-wt
           if ((-0.181*wt)+4.7+delta <= 0) {
             return ('Pathogenic');
           }else if ((-0.583*wt)+1.8+delta >= 0) {
             return ('Benign');
           }else if (((-0.181*wt)+4.7+delta > 0) && ((-0.583*wt)+1.8+delta < 0)) {
             return 'VUS';
           }
        },
        collecte_evidences(pred,af_max){
          af_max = parseFloat(af_max)
          var evidences = '';
          if (pred === 'Pathogenic') {
            evidences+='PM1;';
          }else if (pred === 'Benign') {
            evidences+='BP8;';
          }
          if (af_max >= 0.01) {
            evidences+='BS1;';
          }else if (af_max <= 0.00001) {
            evidences+='PM2;';
          }else if (evidences.length === 0){
            evidences = 'None';
          }
          return evidences;
        },
        prepare_download(){
          var s = "\t"
          //var text = 'Gene'+s+'Pfam_ID'+s+'Logo_position'+s+'HGVSP'+s+'WT'+s+'Delta'+s+'Prediction'+s+'Prediction_probability'+s+"Evidences"+s+'GnomAD_freq'+s+"Dolphin_freq";
          var text = 'Gene'+s+'Pfam_ID'+s+'Logo_position'+s+'HGVSP'+s+'WT'+s+'Delta'+s+"Evidences"+s+'GnomAD_freq'+s+"Dolphin_freq";
          for (var i = 0; i < this.mut_info.length; i++) {
            var e = this.mut_info[i]
            console.log(e)
            //text+="\n"+e.gene+s+e.pfid+s+e.logo+s+e.hgvsp+s+e.wt+s+e.delta+s+e.pred+s+e.proba+s+this.collecte_evidences(e.pred,e.af_max)+s+e.af+s+e.af_max;
            text+="\n"+e.gene+s+e.pfid+s+e.logo+s+e.hgvsp+s+e.wt+s+e.delta+s+this.collecte_evidences(e.pred,e.af_max)+s+e.af+s+e.af_max;
          }
          var filename = "dolphin_scores.txt";
          this.download(filename, text);
        },
        download(filename, text) {
          var element = document.createElement('a');
          element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
          element.setAttribute('download', filename);

          element.style.display = 'none';
          document.body.appendChild(element);

          element.click();
          document.body.removeChild(element);
        }
 		}
 	}
 </script>